export const APP_ROUTES = {
  // Authentication routes
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Main routes
  ROOT: '/',
  DASHBOARD: '/dashboard',
  MY_EXPEDITION: '/my-expedition',
  MANAGE: '/manage',

  // Personalized Curriculum (Campus) routes
  HOME: '/home',
  CURRICULUM: '/curriculum',
  CURRICULUM_PLAN: '/curriculum/plan',
  BOARD: '/board',
  ALL_TRACKS: '/tracks',
  TRACK_DETAIL: '/tracks/:id',

  // Guide: Campus fellows management
  MANAGE_CAMPUS_FELLOWS: '/manage/campus/fellows',
  MANAGE_CAMPUS_FELLOW_DETAIL: '/manage/campus/fellows/:userId',

  // Profile routes
  ACCOUNT: '/account',
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',

  // Tuition routes
  TUITION: '/tuition',
  TUITION_GUEST: '/tuition/:id',
  TUITION_MANAGE: '/tuition/manage',
  TUITION_SUCCESS: '/tuition/success',
  TUITION_FAILED: '/tuition/failed',

  // Settings
  SETTINGS: '/settings',

  // Public routes
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',

  // Error routes
  NOT_FOUND: '/:pathMatch(.*)*',
  PERMISSION_DENIED: '/permission-denied',

  // Auth helpers
  SIGN_IN: '/sign-in',

  // Graduation — /graduation lets the beforeEnter guard pick the right layout
  GRADUATION_FORM: '/graduation',
  GRADUATION: '/manage/graduation',
} as const;

// Public paths that don't require authentication and should not trigger redirect to login on 401
export const PUBLIC_PATHS = [
  APP_ROUTES.LOGIN,
  APP_ROUTES.SIGN_IN,
  APP_ROUTES.REGISTER,
  APP_ROUTES.FORGOT_PASSWORD,
  APP_ROUTES.RESET_PASSWORD,
  APP_ROUTES.TERMS_AND_CONDITIONS,
  APP_ROUTES.PRIVACY_POLICY,
  APP_ROUTES.PERMISSION_DENIED,
  APP_ROUTES.TUITION
] as const;

/**
 * Check if a path is public (doesn't require authentication)
 * Handles both exact paths and dynamic routes (e.g., /tuition/:id)
 */
export function isPublicPath(path: string): boolean {
  // Check exact match
  if (PUBLIC_PATHS.includes(path as any)) {
    return true;
  }

  // Check if path starts with /tuition (handles /tuition/:id, /tuition/123, etc.)
  if (path.startsWith('/tuition')) {
    return true;
  }

  return false;
}

